module.exports = __webpack_public_path__ + "static/media/Copperwood-East-By-laws.19876e18.pdf";